import { render } from "./Destinos.vue?vue&type=template&id=e9f61e68"
import script from "./Destinos.vue?vue&type=script&lang=js"
export * from "./Destinos.vue?vue&type=script&lang=js"

import "./Destinos.vue?vue&type=style&index=0&id=e9f61e68&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\logistica\\AppChoferes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__